// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ge-3";
export var flatBottomCorners = "_ge-5";
export var productImage = "_ge-0";
export var quantityContainer = "_ge-2";
export var quantityHeader = "_ge-6";
export var tooltip = "_ge-1";
export var wrapAndEllipsesOverflow = "_ge-4";